import { useState, useCallback } from 'react';
import { useRestClient } from '../WebServices/useRestClient';

export interface UpdatePersonRequest {
  ContactsRequest?: {
    AddressRequest?: {
      allowCompanySolicitation: number;
      allowTrustedSolicitation: number;
      address1: string;
      address2: string;
      address3Name: string;
      address3Num: number;
      address3Type: number;
      address4: string;
      city: string;
      country: string;
      zipCode: string;
    };
    EmailRequest?: {
      allowCompanySolicitation: number;
      allowTrustedSolicitation: number;
      emailValue: string;
    };
    CellPhoneRequest?: {
      allowCompanySolicitation: number;
      allowTrustedSolicitation: number;
      model: string;
      brand: string;
      dialingCode: string;
      number: string;
    };
  };
  EntityRequest?: {
    entityIdentifier: string;
  };
  PersonRequest?: {
    birthDate: string;
    firstName: string;
    lastName: string;
    title: number;
  };
  IdentifierRequest?: {
    identifierType: number;
    identifierValue: string;
  };
  SubscriptionRequest?: Array<{
    activate: boolean;
    id: number;
    source: string;
  }>;
}

export interface UpdatePersonResponse {
  responseCode?: number | string;
  infos?: string;
  message?: string;
}

const useUpdatePersonREST = () => {
  const callRest = useRestClient();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<UpdatePersonResponse | null>(null);

  const updatePerson = useCallback(
    async (params: UpdatePersonRequest) => {
      setLoading(true);
      setError(null);
      try {
        const result = await callRest<UpdatePersonResponse>(
          '/rest/2.0/personWebService/updatePerson',
          {
            method: 'POST',
            body: params,
            useAuth: true
          }
        );
        setData(result);
        return result;
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Erreur lors de la mise à jour';
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [callRest]
  );

  return { updatePerson, loading, error, data };
};

export default useUpdatePersonREST;
